import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataResult } from "@progress/kendo-data-query";
import { Observable } from "rxjs";
import { AppConstant } from "src/app/app.constant";
import { map } from 'rxjs/operators';
import { DataToDelete } from "src/app/_metronic/core/classes/core.class";

@Injectable()
export class LocationService {
    apiUrl: string;
    kendoDataUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl();
    }
    manageLocation(location) {
        return this.httpClient.post(`${this.apiUrl}/manageLocation`, location).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public getAllLocation(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllLocation/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    public getAllLocationName() {
        return this.httpClient.get(`${this.apiUrl}/getAllLocationName/`).pipe(
            map((response: any) => {
                return response
            })
        )
    }
    public downloadExcelLocation() {
        return this.httpClient.get(`${this.apiUrl}/downloadExcelLocation`, { responseType: 'blob' })
    }
    bulkDeleteLocation(sectionIdNameList: Array<DataToDelete> = []) {
        return this.httpClient.post(`${this.apiUrl}/bulkDeleteLocation/`, {
            DataToDelete: sectionIdNameList
        }).pipe(
            map((response: any) => {
                return response;
            }))
    }
    bulkInsert(locationData) {
        return this.httpClient.post(`${this.apiUrl}/bulkImportLocation`, locationData).pipe(
          map((response: any) => {
            return response;
          })
        )
      }
}